import React, { useEffect, useState } from "react";
import translations from '../hooks/translation/translations.json'
import { ExclamationCircleOutlined } from "@ant-design/icons";

function TabErrorControl(errors, title, end) {

    const [error,setError] =useState();

    useEffect(()=>errors && setError(Object.keys(errors)?.filter((value) => value.endsWith(end) && errors[value] != null).length),[errors])

  return (
    <div className={error && 'error-tab'}>
      {translations["ka"][title]} {error > 0 && <>{error} <ExclamationCircleOutlined /></>}
    </div>
  );
}

export default TabErrorControl;
